import { createSyncAction } from '@bimser/core';
import * as ActionTypes from '../actionTypes';
import { IWebInterfaceAction, WebInterfaceActionFactoryFromJS } from '../../../../common/entities';

const updateVisibleActionsTransaction = (data: IWebInterfaceAction) =>
	createSyncAction(
		ActionTypes.UPDATE_VISIBLE_ACTIONS_TRANSACTION,
		WebInterfaceActionFactoryFromJS(data)
	);

export default updateVisibleActionsTransaction;
